/** @format */

export interface AddressAccountSettings {
  addressId: number;
  addressLines: string[];
  city: string;
  country: string;
  email: string;
  firstName: string;
  lastName: string;
  nickName: string;
  phone: string;
  primary: boolean;
  state: string;
  zipCode: string;
}
